export const LOADING = 'LOADING';